// Pre-baked responsive-variant loader for next/image (storefront).
//
// Product images on the CDN carry a fixed ladder of WebP variants generated at
// upload time (see admin src/modules/r2-file/variants.ts) named
// `<base>__w<W>.webp` beside the original. This loader maps next/image's
// requested width to the nearest ladder rung and points <Image> straight at that
// static object — no runtime resize, pure CDN edge cache. Keep VARIANT_LADDER in
// sync with the generator and the backfill script.
//
// Passthrough (return src untouched) for anything without a variant: non-CDN
// hosts, data:/blob:, the portal presigned proxy, already-variant keys, and
// non-raster formats (svg/gif). That decision lives in `image-variants.js`,
// because the components need the same answer: a passthrough source must be
// rendered `unoptimized`, otherwise next/image prints a srcset of four identical
// URLs and warns «loader property that does not implement width».
//
// The no-404 guarantee holds because the generator always emits every rung
// (capped to the source width, never upscaled).

import { VARIANT_LADDER, hasPrebakedVariants } from "./image-variants"

export default function imageLoader({ src, width }) {
  if (!hasPrebakedVariants(src)) return src

  const rung =
    VARIANT_LADDER.find((w) => w >= width) || VARIANT_LADDER[VARIANT_LADDER.length - 1]
  const clean = src.split(/[?#]/)[0]
  const base = clean.replace(/\.[^./]+$/, "")
  return `${base}__w${rung}.webp`
}
